module.exports = __webpack_public_path__ + "static/media/90400-Inox.4cae42a5.png";